import React from 'react'
import Card from '@mui/material/Card'
import CardContent from '@mui/material/CardContent'
import CircularProgress from '@mui/material/CircularProgress'
import Box from '@mui/material/Box'
import Typography from '@mui/material/Typography'
import createPlotlyComponent from 'react-plotly.js/factory'
import Plotly from 'plotly.js-basic-dist-min'

const Plot = createPlotlyComponent(Plotly)

const SINGLE_COLOR = '#0b8043'
const RECURRING_COLOR = '#7b1fa2'

// data shape:
//   {
//     irto: { current: number|null, previous: number|null },
//     vakio: { current: number|null, previous: number|null },
//   }
const OccupancyByTypeCard = ({ title = 'Varausaste irto / vakio', data, loading, currentLabel = 'Tämä viikko', previousLabel = 'Viime viikko' }) => {
  const irtoCur = data && data.irto && data.irto.current
  const irtoPrev = data && data.irto && data.irto.previous
  const vakioCur = data && data.vakio && data.vakio.current
  const vakioPrev = data && data.vakio && data.vakio.previous
  const hasData = [irtoCur, irtoPrev, vakioCur, vakioPrev].some((v) => v !== null && v !== undefined)

  const xs = ['Irto', 'Vakio']
  const traces = [
    {
      x: xs,
      y: [Number(irtoPrev) || 0, Number(vakioPrev) || 0],
      name: previousLabel,
      type: 'bar',
      marker: { color: '#cfd8dc' },
      hovertemplate: `%{x}: %{y:,.1f} %<extra>${previousLabel}</extra>`,
    },
    {
      x: xs,
      y: [Number(irtoCur) || 0, Number(vakioCur) || 0],
      name: currentLabel,
      type: 'bar',
      marker: { color: [SINGLE_COLOR, RECURRING_COLOR] },
      hovertemplate: `%{x}: %{y:,.1f} %<extra>${currentLabel}</extra>`,
    },
  ]

  const layout = {
    autosize: true,
    height: 200,
    margin: { l: 50, r: 12, t: 4, b: 30 },
    barmode: 'group',
    showlegend: true,
    legend: { orientation: 'h', x: 0, y: 1.18, font: { size: 11 } },
    xaxis: { tickfont: { size: 11, color: '#5f6368' } },
    yaxis: { tickfont: { size: 11, color: '#5f6368' }, gridcolor: 'rgba(0,0,0,0.06)', tickformat: ',.0f', ticksuffix: ' %' },
    paper_bgcolor: 'transparent',
    plot_bgcolor: 'transparent',
    separators: ', ',
    hoverlabel: { bgcolor: '#fff' },
  }

  const config = { displayModeBar: false, responsive: true }

  return (
    <Card sx={{ borderRadius: 2, height: '100%' }}>
      <CardContent sx={{ p: '12px 14px', '&:last-child': { pb: '12px' } }}>
        <Typography variant='caption' sx={{ color: 'text.secondary', textTransform: 'uppercase', letterSpacing: 0.3 }}>
          {title}
        </Typography>
        {loading ? (
          <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', height: 200 }}>
            <CircularProgress size={20} />
          </Box>
        ) : !hasData ? (
          <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', height: 200, color: 'text.secondary', fontSize: 12, textAlign: 'center', px: 2 }}>
            Irto / vakio -erittely vaatii backend-päivityksen.<br />Tieto ilmestyy heti, kun palvelin lähettää sen.
          </Box>
        ) : (
          <Plot data={traces} layout={layout} config={config} style={{ width: '100%', height: 200 }} useResizeHandler />
        )}
      </CardContent>
    </Card>
  )
}

export default OccupancyByTypeCard
